module.exports = __webpack_public_path__ + "static/media/app_banner.1714f631.jpg";